<template>
  <article id="about" class="layout-section -bg-shade">
    <section class="layout-section__align-side">
      <figure v-scroll:reveal class="layout-section__figure" :style="{ backgroundImage: `url('${content.image}')` }" />

      <div class="layout-section__content">
        <h2 v-scroll:reveal="{delay:75}" class="layout-section__heading">{{ content.title }}</h2>
        <div v-scroll:reveal="{delay:125}" v-html="content.text" />
      </div>
    </section>

    <!-- <section class="layout-section__responsive-zone layout__responsive-tablet-show">
      <p v-scroll:reveal="{delay:120}">Dans sa version acoustique, chaque tableau est doublé d'une laine acoustique de 1 1/2'' ultra performante qui offre un indice NRC de 0,85, afin de réduire les nuisances sonores et faire de votre environnement un endroit à la fois paisible et ludique. Vous n'avez pas besoin de fonction acoustique accrue? Optez pour la version régulière tout simplement!</p>
    </section> -->
  </article>
</template>

<script>
export default {
  name: 'HomeContent',
  computed: {
    content() {
      return this.$i18n.t('intro')
    }
  }
}
</script>
